import { GAME_ID, REDUX_ACTIONS } from 'a/zoomBoom/data/constants';
import AlexStates from 'a/components/GameHeader/AlexStates';

const initialState = AlexStates.INACTIVE;

const alexReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_ALEX_STATE:
      return payload;

    default:
      return state;
  }
};

export default alexReducer;
